import script from "./Home.vue?vue&type=script&setup=true&lang=ts"
export * from "./Home.vue?vue&type=script&setup=true&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=598b96cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598b96cc"]])

export default __exports__